import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { saveDraft, listDrafts, deleteDraft } from '../Api/draftsApi';

export function useDraftList(poCode) {
  return useQuery({ queryKey: ['sfa', 'list', 'drafts', poCode ?? ''], queryFn: () => listDrafts(poCode) });
}

export function useSaveDraft() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: saveDraft,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['sfa', 'list', 'drafts'] });
      toast.success('Saved as draft.');
    },
    onError: (err) => toast.error(err?.friendlyMessage || 'Could not save draft.'),
  });
}

export function useDeleteDraft() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: deleteDraft,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['sfa', 'list', 'drafts'] });
      toast.success('Draft discarded.');
    },
    onError: (err) => toast.error(err?.friendlyMessage || 'Could not discard draft.'),
  });
}
